/**
 * Replaces the `v-clipboard` package, whose only Vue 3 build is a prerelease.
 *
 * Only `$clipboard(text)` is used — 40 call sites across 18 components; the
 * `v-clipboard:copy` directive form is used nowhere. No call site reads the
 * return value.
 *
 * Deliberately NOT built on `navigator.clipboard`. Call sites already try that
 * first and fall back to `$clipboard` "for ancient / insecure contexts" — see
 * CodeBlock.vue and UseKit/index.vue, where the async API is unavailable
 * because the click's user gesture originates inside a shadow root. Rebuilding
 * this on the async API would make the fallback fail in exactly the cases it
 * exists for, so it keeps the synchronous execCommand approach.
 */
const copy = (text) => {
  const textarea = document.createElement('textarea')

  textarea.value = text
  // Keep it out of view and out of the layout, and stop iOS zooming to it.
  textarea.setAttribute('readonly', '')
  textarea.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;'

  document.body.appendChild(textarea)

  const selection = document.getSelection()
  const previous = selection.rangeCount > 0 ? selection.getRangeAt(0) : null

  textarea.select()
  textarea.setSelectionRange(0, textarea.value.length)

  let copied = false
  try {
    copied = document.execCommand('copy')
  } catch (e) {
    copied = false
  }

  document.body.removeChild(textarea)

  // Restore whatever the user had selected before the copy.
  if (previous) {
    selection.removeAllRanges()
    selection.addRange(previous)
  }

  return copied
}

export default (vueInstance) => {
  vueInstance.config.globalProperties.$clipboard = copy
}
